import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=a1ffcfc0&scoped=true"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"
import style0 from "./Chart.vue?vue&type=style&index=0&id=a1ffcfc0&prod&scoped=true&lang=css"
import style1 from "./Chart.vue?vue&type=style&index=1&id=a1ffcfc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ffcfc0",
  null
  
)

export default component.exports